import React from 'react'
import axios from 'axios';
import { useState, useEffect } from 'react';
import { RiCommunityLine } from "react-icons/ri";
import "./TopBar.css"

function TopBar({ apiClubData }) {

  const [clubName, setClubName] = useState([]);

  // Fetch business data from the API- /benefit_offer
  useEffect(() => {
    const getData = async () => {
      try {
        const response = await Promise.all([axios.get(apiClubData)]);
        setClubName(response[0].data.name);
      } catch (error) {
        console.error('Error fetching business data:', error);
      }
    };

    getData();
  }, [apiClubData]);

  return (
    <nav className="topbar">
      <div className="topbar-container">
        <div className="logo-container">
          <RiCommunityLine className="Companylogo-icon" />
          <span className="logo-text">{clubName || ""}</span>
        </div>

        {/* Container for the navigation links */}
        <div className="nav-links">
          <a href="#" className="nav-link">Dashboard</a>
          <a href="#" className="nav-link">Benefits</a>
          <a href="#" className="nav-link">Community</a>
        </div>
      </div>
    </nav>
  )
}

export default TopBar;
